function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m300 480c99.410156 0 180-80.589844 180-180s-80.589844-180-180-180-180 80.589844-180 180c.117188 99.367188 80.632812 179.882812 180 180zm0-340c88.363281 0 160 71.636719 160 160s-71.636719 160-160 160-160-71.636719-160-160c.101562-88.320312 71.679688-159.898438 160-160zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m300 600c5.523438 0 10-4.476562 10-10v-80c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v80c0 5.523438 4.476562 10 10 10zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m300 100c5.523438 0 10-4.476562 10-10v-80c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v80c0 5.523438 4.476562 10 10 10zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m142.929688 157.070312c3.925781 3.789063 10.160156 3.734376 14.019531-.121093 3.855469-3.859375 3.910156-10.09375.121093-14.019531l-60-60c-3.925781-3.789063-10.160156-3.734376-14.019531.121093-3.855469 3.859375-3.910156 10.09375-.121093 14.019531zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m457.070312 442.929688c-3.925781-3.789063-10.160156-3.734376-14.019531.121093-3.855469 3.859375-3.910156 10.09375-.121093 14.019531l60 60c3.925781 3.789063 10.160156 3.734376 14.019531-.121093 3.855469-3.859375 3.910156-10.09375.121093-14.019531zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m450 160c2.652344 0 5.195312-1.054688 7.070312-2.929688l60-60c3.789063-3.925781 3.734376-10.160156-.121093-14.019531-3.859375-3.855469-10.09375-3.910156-14.019531-.121093l-60 60c-2.855469 2.859374-3.714844 7.164062-2.167969 10.898437s5.195312 6.171875 9.238281 6.171875zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m590 290h-80c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h80c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m10 310h80c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-80c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m97.070312 517.070312 60-60c3.789063-3.925781 3.734376-10.160156-.121093-14.019531-3.859375-3.855469-10.09375-3.910156-14.019531-.121093l-60 60c-2.597657 2.507812-3.640626 6.230468-2.726563 9.726562s3.644531 6.226562 7.140625 7.140625 7.21875-.128906 9.726562-2.726563zm0 0"
});

function SvgClearDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "640pt",
    viewBox: "-20 -20 640 640",
    width: "640pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDay);
export default __webpack_public_path__ + "static/media/clear_day.d56de315.svg";
export { ForwardRef as ReactComponent };